import styled from '@emotion/styled';
import { PropsWithChildren } from 'react';
import tw from 'twin.macro';

import { Card, CardHeader } from '../Card';

export const Container = styled.div`
  margin: 0 auto;
  max-width: 500px;
  width: 50vw;
  ${tw`mt-4`}
`;

type Props = PropsWithChildren<{
  header: string;
}>;

export function SingleCenterCard(props: Props) {
  return (
    <Container>
      <Card>
        <CardHeader>{props.header}</CardHeader>
        {props.children}
      </Card>
    </Container>
  );
}

export default SingleCenterCard;
